import type { IStyle } from 'fela';

import type { Theme } from '../types';

// Colours are chosen as a pair: a view without a theme gets a neutral pair,
// a themed view keeps whatever it set.
const headerColors = (theme?: Theme): IStyle =>
  theme
    ? {
        backgroundColor: theme.header?.style?.backgroundColor ?? 'initial',
        color: theme.header?.style?.color ?? 'initial'
      }
    : { backgroundColor: '#2d2d2d', color: '#fff' };

export const container: (theme?: Theme) => IStyle = (theme) => ({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  lineHeight: theme?.header?.style?.fontSize ?? '24px',
  marginBottom: '40px',
  paddingBottom: '40px',
  paddingTop: '40px',
  tabSize: '4',
  textSizeAdjust: '100%',
  ...headerColors(theme),
  '> a': {
    textDecoration: 'none'
  }
});

export const heading: (theme?: Theme) => IStyle = (theme) => ({
  textAlign: 'center',
  boxSizing: 'border-box',
  cursor: 'pointer',
  display: 'block',
  margin: '20px',
  tabSize: '4',
  textDecorationThickness: 'auto',
  textSizeAdjust: '100%',
  fontFamily: theme?.header?.font?.family ?? 'inherit',
  fontSize: theme?.header?.style?.fontSize ?? '24px'
});
